import { DatePipe } from '@angular/common';
import { Component, OnInit , Input, ViewChild, SimpleChanges} from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Table } from 'primeng/table';
import { LabRequisitionStatus } from 'src/app/enum/water-lab/LabRequisitionStatus';
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';
import { ShippingManifestData } from 'src/app/models/water-lab/shipping-manifest';
import { CustomDialogService, LabRequestService, LabRequisitionService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { PreviewLabelComponent } from '../../request/preview-label/preview-label.component';
import { CancelComponent } from './cancel/cancel.component';
import { EnterDrawDateComponent } from './enter-draw-date/enter-draw-date.component';
import { AdditionalTestComponent } from '../additional-test/additional-test.component';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { CustomDatePipe } from 'src/app/pipes';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';
@Component({
  selector: 'bart-pending-manifest',
  templateUrl: './pending-manifest.component.html',
  styleUrls: ['./pending-manifest.component.scss'],
  providers : [NgbDropdownConfig,DatePipe, CustomDialogService,CustomDatePipe]
})
export class PendingManifestComponent implements OnInit {
@Input() selectedFacilityMasterId : number;
@Input() facilities :UserLocationFacility [];
allPendingManifestData: ShippingManifestData[];
pendingManifestData: ShippingManifestData[];
selectedManifestData : ShippingManifestData[]=[];
isPrintManifest:boolean=false;
facilityDisplayName:string;
userInfo: UserDetail;
workFlow:string;
distinctWorkFlowManifest:ShippingManifestData[]=[];
@ViewChild('pendingManifestTable', { static: false }) pendingManifestTable: Table;
cols: any[];
  isHeaderCheckBoxChecked: boolean;
  btnPrintLabelDisabled:boolean=true;
  btnDrawDateDisabled:boolean=true;
  btnPrintOfficialManifestDisabled:boolean=true
  labRequisitionIds: string;
  public ENUM_WORKFLOW = WorkFlow;
  
  constructor
  (
    private _loaderService: LoaderService,
    public dialogService: CustomDialogService,
    private _requisitionService : LabRequisitionService,
    config: NgbDropdownConfig,
    private customDatePipe :CustomDatePipe,
    private _labRequestService:LabRequestService,
    private _userService:UserService
  ) 
  {
    config.placement = 'bottom-start';
    config.autoClose = true;   
    this.userInfo = AccessUserInfo.getUserInfo(); 
  }
  ngOnInit() 
  {
      this.cols = 
      [
        { field: 'LabRequisitionNumber', header: 'Requisition ID' ,display: 'table-cell', width: "10%" },
        { field: 'LabRequestID', header: 'Request ID',display: 'table-cell', width: "8%"  },
        { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID', display: 'table-cell', width: "23%" },
        { field: 'WorkFlow', header: 'Workflow', display: 'table-cell', width: "9%" },
        { field: 'TestDisplayName', header: 'Test ID | Name' ,display: 'table-cell', width: "17%" },
        { field: 'LabContainerID', header: 'Container',display: 'table-cell', width: "7%"  },
        { field: 'PrintLabelDate', header: 'Printed',display: 'table-cell', width: "8%"  },
        { field: 'DrawDate', header: 'Draw Date',display: 'table-cell', width: "8%"  },  
      ];
  }
  ngOnChanges(changes: SimpleChanges) 
  {
    let currentValue:any;
    let previousValue:any;
    if(changes && changes.selectedFacilityMasterId)
    {
      previousValue=changes.selectedFacilityMasterId.previousValue
      currentValue=changes.selectedFacilityMasterId.currentValue
      if(previousValue!=currentValue)
      {
        let locationModality=this.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).LocationModality
        this.facilityDisplayName=this.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName;
         this.workFlow="";
        this.facilityChanged();
      }
    }
    
  }
  facilityChanged()
  {
    this.loadPendingManifestData();
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "FacilityMasterID",
      value: this.selectedFacilityMasterId,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_GRID_LOADED
    });
  }
  /*.... Manifest Data API.......*/
  loadPendingManifestData()
  {
    this._loaderService.show();
    let param = 
    {
      "GETLABREQUISITIONS": 
      {
          "FacilityMasterID":this.selectedFacilityMasterId, 
          "LabRequisitionStatusID":LabRequisitionStatus.Pending+","+ LabRequisitionStatus.PartiallyShipped ,
          "Month":  null ,
          "Year": null,
      }
    }
    this.resetTable();
    this.pendingManifestData=[];
    this._requisitionService.getLabRequisitions(param).subscribe(response =>
    {
      this.allPendingManifestData=response.getLabRequisitions;
      if(this.allPendingManifestData  && this.allPendingManifestData.length)
      {
        
        this.allPendingManifestData.forEach(item =>{
          item.isDisabled=false
          item.PrintLabelDate=this.customDatePipe.transform(item.PrintLabelDate,"local","MM/dd/yyyy HH:mm");
          item.PrintLabelDateSort=new Date (this.customDatePipe.transform(item.PrintLabelDate,"local","MM/dd/yyyy HH:mm"));
          item.DrawDate=this.customDatePipe.transform(item.DrawDate,"local","MM/dd/yyyy HH:mm");
          item.DrawDateSort=new Date (this.customDatePipe.transform(item.DrawDate,"local","MM/dd/yyyy HH:mm"));
        });
      }
      this.pendingManifestData=Object.assign([],this.allPendingManifestData)
      this.distinctWorkFlowManifest = this.allPendingManifestData?this.allPendingManifestData.filter((x, i, arr) => arr.findIndex(t => t.WorkFlow === x.WorkFlow) === i):null;
      if(this.distinctWorkFlowManifest  && this.distinctWorkFlowManifest .length)
      {
        this.distinctWorkFlowManifest.sort((a,b) => a.WorkFlow.localeCompare(b.WorkFlow));
        if(!this.distinctWorkFlowManifest.filter(x=>x.WorkFlow==this.workFlow).length)
        {
          this.workFlow=this.distinctWorkFlowManifest[0].WorkFlow;
        }
        this.pendingManifestData=this.allPendingManifestData.filter(x=>x.WorkFlow==this.workFlow);
      }
      this._loaderService.hide()
    },
    (error)=>
    {
      this._loaderService.hide()
    });

  }
  /*................................*/

  /*....table events starting.......*/
  resetTable(isTableReset:boolean=true)
  {
    if (this.pendingManifestTable && isTableReset) {
      this.pendingManifestTable.reset();
    }
    this.selectedManifestData = [];
    this.isHeaderCheckBoxChecked = false;
    this.checkActionButtonStatus();
  }
  onFilter(event)
  {
    this.resetTable(false);
  }
  sortColumn(event)
  {
    this.resetTable(false)
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_COLUMN_SORT
    });
    //#endregion
  }
  paginate(event) 
  {
    this.manageCheckBoxSelection()
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_PAGE_NO_CLICKED
    });
    //#endregion
  }
  /*....table events ending.................*/

  //#region Business Rules for show/hode action buttons & Check Box Selections
  headerCheckBoxChecked()
  {
    let pageOfItems = this.pendingManifestData ? this.pendingManifestData.slice(this.pendingManifestTable.first, (this.pendingManifestTable.first + this.pendingManifestTable.rows)) : [];
    if(this.pendingManifestTable.filteredValue)
    {
      pageOfItems=this.pendingManifestTable.filteredValue.slice(this.pendingManifestTable.first, (this.pendingManifestTable.first + this.pendingManifestTable.rows));
    }
    if (this.isHeaderCheckBoxChecked) 
    {
      let activeObj = pageOfItems.filter(x => x.isDisabled==false);
      this.selectedManifestData = this.selectedManifestData.concat(activeObj);
    }
    else 
    {
      let activeObj = pageOfItems.filter(x => x.isDisabled==false);
      this.selectedManifestData = this.selectedManifestData.filter(ar => !activeObj.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    }
    this.checkActionButtonStatus();
  }
  rowCheckBoxChecked(isDisabled)
  {
    if(isDisabled)
    {
      return false;
    }
    this.manageCheckBoxSelection();
    this.checkActionButtonStatus();
  }
  manageCheckBoxSelection() 
  {
    let pageOfItems = this.pendingManifestData ? this.pendingManifestData.slice(this.pendingManifestTable.first, (this.pendingManifestTable.first + this.pendingManifestTable.rows)) : [];
    if(this.pendingManifestTable.filteredValue)
    {
      pageOfItems=this.pendingManifestTable.filteredValue.slice(this.pendingManifestTable.first, (this.pendingManifestTable.first + this.pendingManifestTable.rows));
    }
    let activeObjA = pageOfItems.filter(x => x.isDisabled==false);
    let activeObjB = this.selectedManifestData.filter(ar => activeObjA.find(rm => (rm.LabRequisitionID === ar.LabRequisitionID)))
    if (activeObjA.length == activeObjB.length && activeObjA.length > 0) 
    {
      this.isHeaderCheckBoxChecked = true;
    }
    else 
    {
      this.isHeaderCheckBoxChecked = false;
    }
    
  }
  checkActionButtonStatus()
  {
    this.btnPrintLabelDisabled=true;
    this.btnDrawDateDisabled=true;
    this.btnPrintOfficialManifestDisabled=true;
    if(this.selectedManifestData && this.selectedManifestData.length)
    {
      this.btnPrintLabelDisabled=false;// Enabled Print Label Button Status
      if(this.ENUM_WORKFLOW.HOME==this.workFlow)  //Need to check after today meeting discussion
      {
        this.btnPrintLabelDisabled=true
      }
      let objDrwaDate=this.selectedManifestData.filter(x=>x.DrawDate!=null);
      let objPrintDate=this.selectedManifestData.filter(x=>x.PrintLabelDate == null)
      this.btnDrawDateDisabled=false
      if((objPrintDate && objPrintDate.length) || (objDrwaDate && objDrwaDate.length))
      {
        this.btnDrawDateDisabled=true
      }
      this.btnPrintOfficialManifestDisabled=false;
      let objManifest=this.selectedManifestData.filter(x=>x.DrawDate==null || x.PrintLabelDate==null);
      if((objManifest && objManifest.length) || this.ENUM_WORKFLOW.HOME==this.workFlow) //Need to check after today meeting discussion
      {
        this.btnPrintOfficialManifestDisabled=true
      }
    }
  }
  //#endregion Business Rules for show/hode action buttons & Check Box Selections


  /*....Action button popups starting.......*/
  openActionItem(type,data){
    let userActionDesc;
    if(type == 'cancel'){
      const ref = this.dialogService.open(CancelComponent, {
        header: `Confirm Cancellation ${data.LabRequisitionNumber}`,
        width: '45%',
        data: {data}
      });
      ref.onClose.subscribe(ref => {
        if(ref){
          this.facilityChanged();
        }
      });
      userActionDesc = UserActionDescription.SHIPPING_MANIFEST_PENDING_ELLIPSES_CANCEL_CLICKED;
    }
    if(type == 'addTest'){
      const ref = this.dialogService.open(AdditionalTestComponent, {
        header: 'Lab Request',
        width: '70%',
        styleClass:'additional-test-popup',
        data: {
          data: data,
          workFlow:this.workFlow//Need to check after today meeting discussion
        }
  
      });
      ref.onClose.subscribe(ref => {
        if(ref){
          this.facilityChanged();
        }
      });
      userActionDesc =UserActionDescription.SHIPPING_MANIFEST_PENDING_ELLIPSES_ADD_TEST_TO_REQUEST_CLICKED;
       
    }
    if(type == 'EditDrawDate'){
      const ref = this.dialogService.open(EnterDrawDateComponent, {
        header: 'Edit Draw Date',
        width: '55%',
        showHeader:false,
        closeOnEscape:false,
        data:{data: [data], isEdit : true,workFlow:this.workFlow } //Need to check after today meeting discussion
      });
      ref.onClose.subscribe(ref => {
        if(ref && ref.refresh)
        {
          this.facilityChanged();
        }
      });
      userActionDesc = UserActionDescription.SHIPPING_MANIFEST_PENDING_ELLIPSES_EDIT_DRAW_DATE_CLICKED;
    }
    if(type == 'PrintLabel')
    {
      this.selectedManifestData=[];
      this.selectedManifestData.push(data)
      this.openPreviewLabelPopup();
      userActionDesc = UserActionDescription.SHIPPING_MANIFEST_PENDING_ELLIPSES_PRINT_LABEL_CLICKED;
    }
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: data.LabRequisitionID,
      eventDescription:userActionDesc
    });
    //#endregion

  }
  openEnterDrawDatePopup(){
    const ref = this.dialogService.open(EnterDrawDateComponent, {
      header: 'Enter Draw Date',
      width: '55%',
      styleClass:'draw-date-popup',
      showHeader:false,
      closeOnEscape:false,
      data: {data: this.selectedManifestData, isEdit : false,workFlow:this.workFlow }//Need to check after today meeting discussion
    });
    ref.onClose.subscribe(data => {
      // if(data)
      // {
      //   this.selectedManifestData= this.selectedManifestData.filter(a => data.some(b => b.LabRequisitionID === a.LabRequisitionID));
      //   this.manageCheckBoxSelection()
      // }
      this.checkActionButtonStatus();
    });

    
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.ENTER_DRAW_DATE,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: this.selectedManifestData.map(x => x.LabRequisitionID).join(","),
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_CLICKED
    });
    //#endregion
  }
  openPreviewLabelPopup() {
    
    const ref = this.dialogService.open(PreviewLabelComponent, {
      header: this.ENUM_WORKFLOW.HOME==this.workFlow?'Print Home Label Summary':'Print Label Summary', //Need to check after today meeting discussion
      styleClass:"preview-label-summary-popup",
      data:
      {
        labRequisitionId:this.selectedManifestData.map(x => x.LabRequisitionID).join(","),
        facilityMasterId:this.selectedFacilityMasterId,
        facilityDisplayName:this.facilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).FacilityDisplayName,
        workFlow:this.workFlow,//Need to check after today meeting discussion
        isFromPendingManifest : true,
        selectedRows:this.selectedManifestData
      }
    });
    ref.onClose.subscribe(ref => {
      this.checkActionButtonStatus();
    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.PRINT_LABEL_SUMMARY,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: this.selectedManifestData.map(x => x.LabRequisitionID).join(","),
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_PRINT_LABEL_CLICKED
    });
    //#endregion
  }
  /*...............Action button popups Eding.............................*/
  
  printManifest()
  {
    
    this._loaderService.show();
    this.isPrintManifest=true;
     //#region User Action Audit
     this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: this.selectedManifestData.map(x => x.LabRequisitionID).join(","),
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_PRINT_OFFICIAL_MANIFEST_CLICKED
    });
    //#endregion
    this.labRequisitionIds=this.selectedManifestData.map(x => x.LabRequisitionID).join(",");
  }  

  printPDFLoaded()
  {
    this.labRequisitionIds="";   
    this.isPrintManifest=false; 
    this.loadPendingManifestData();      
  }  
  ellipseClick(data)
  {
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: data.LabRequisitionID,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_ELLIPSES_CLICKED
    });
    //#endregion
  }
  workFlowChanged()
  {   this.resetTable();
      this.pendingManifestData=this.allPendingManifestData.filter(x=>x.WorkFlow==this.workFlow);
      //this.formatDateInPendingManifestData();
  }
}
